/** HR-issued profile-update magic link TTL (days). */
export const EMPLOYEE_PROFILE_UPDATE_LINK_DAYS = 7;
export const EXTERNAL_CANDIDATE_PROFILE_UPDATE_LINK_DAYS = 30;

export function profileUpdateLinkExpiresInDays(profileCategory?: string | null): number {
  return (profileCategory || '').toLowerCase() === 'employee'
    ? EMPLOYEE_PROFILE_UPDATE_LINK_DAYS
    : EXTERNAL_CANDIDATE_PROFILE_UPDATE_LINK_DAYS;
}

export function formatProfileUpdateLinkExpiry(expiresAt: string | null | undefined): string | null {
  if (!expiresAt) return null;
  const date = new Date(expiresAt);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString(undefined, { dateStyle: 'medium' });
}
